import Checkbox from "@mui/material/Checkbox";

export const BULK_TRANSFER_TABLE = [
  {
    displayName: Checkbox,
    key: "checkBox",
  },
  {
    displayName: "Id",
    key: "id",
  },
  {
    displayName: "Name",
    key: "name",
  },
];

export const BULK_TRANSFER_MEMBER_TABLE = [
  {
    displayName: Checkbox,
    key: "checkBox",
  },
  {
    displayName: "Id",
    key: "id",
  },
  {
    displayName: "Name",
    key: "name",
  },
  {
    displayName: "Division",
    key: "divisionName",
  },
  {
    displayName: "Address",
    key: "addressLine1",
  },
];
